module.exports = __webpack_public_path__ + "static/13-7aacb81ae9fe98b93d262bfaf4304c40.jpg";